import { stripHTML } from "../../../text"

const hasVisibleText = (value = "") => {
  return stripHTML(value).length > 0
}

export const getValidLikertScale = (data: Record<string, any> = {}) => {
  const scale = data.scale || []

  return scale.filter(
    (option) => option?.scaleOptionID && Number.isInteger(option.numericValue)
  )
}

export const getValidLikertStatements = (data: Record<string, any> = {}) => {
  const statements = data.statements || []

  return statements.filter(
    (statement) => statement?.statementID && hasVisibleText(statement.label)
  )
}

export const getValidLikertResponses = (data: Record<string, any> = {}) => {
  const validStatementIDs = new Set(
    getValidLikertStatements(data).map((statement) => statement.statementID)
  )
  const validOptionIDs = new Set(
    getValidLikertScale(data).map((option) => option.scaleOptionID)
  )
  const validResponses = (data.answer?.responses || []).filter(
    (response) =>
      response?.statementID &&
      response?.selectedScaleOptionID &&
      validStatementIDs.has(response.statementID) &&
      validOptionIDs.has(response.selectedScaleOptionID)
  )

  return validResponses.filter(
    (response, index, responses) =>
      responses.findIndex(
        (candidate) => candidate.statementID === response.statementID
      ) === index
  )
}

export const hasCompleteLikertResponses = (data: Record<string, any> = {}) => {
  const statements = getValidLikertStatements(data)

  if (!statements.length) return false
  if (!getValidLikertScale(data).length) return false

  const answeredStatements = new Set(
    getValidLikertResponses(data).map((response) => response.statementID)
  )

  return statements.every((statement) =>
    answeredStatements.has(statement.statementID)
  )
}

// Match Question blocks: the persisted submission flag is authoritative.
export const isLikertScaleComplete = (data: Record<string, any> = {}) =>
  data.answer?.hasSubmitted === true

export const resolveUserCompletion = (context, data, layout) => {
  const progress = isLikertScaleComplete(data) ? 1 : 0

  return Promise.resolve({
    progress,
    score: null
  })
}
